import { render, staticRenderFns } from "./InputFieldCurrency.vue?vue&type=template&id=641d1fa3&scoped=true"
import script from "./InputFieldCurrency.vue?vue&type=script&lang=js"
export * from "./InputFieldCurrency.vue?vue&type=script&lang=js"
import style0 from "./InputFieldCurrency.vue?vue&type=style&index=0&id=641d1fa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641d1fa3",
  null
  
)

export default component.exports